<template>
  <van-popup
    v-model="kaiguan"
    round
    lazy-render
    :style="{background:'transparent'}"
    @click-overlay="closeLogin"
  >
    <div class="myprize">
      <p class="title">我的奖品</p>
      <ul class="all-prize">
        <li class="one-prize" v-for="item in goodslist" :key="item.drawId">
          <p class="goods">{{item.prize}}</p>
          <p class="msg">{{item.status === 1 ? '已领取' : '未领取'}}</p>
          <p class="ctime">{{item.ctime}}</p>
          <button
            class="btn"
            v-if="item.status !== 1"
            @click.stop="$emit('complete',{...item,from:'prize'})"
          >领取</button>
        </li>
      </ul>
    </div>
  </van-popup>
</template>

<script>
// import { my_prize } from "../config";
export default {
  name: "myprize",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    goodslist: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    kaiguan: {
      get: function() {
        return this.show === true;
      },
      set: function() {
        return;
      }
    }
  },
  watch: {
    show: function() {
      return;
    }
  },
  methods: {
    closeLogin() {
      this.$emit("changemyprize");
    }
  }
};
</script>

<style lang="scss" scoped>
.myprize {
  background-color: #112b5d;
  color: #fff;
  padding: 40px 40px 45px 40px;
  width: 580px;
  box-sizing: border-box;
  height: 625px;
  overflow: hidden;
  .title {
    font-size: 28px;
    color: #fff;
    text-align: center;
    margin-bottom: 20px;
  }
  .all-prize {
    width: 100%;
    height: 100%;
    padding-bottom: 40px;
    box-sizing: border-box;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .one-prize {
      margin-bottom: 10px;
      margin-bottom: 30px;
      color: #fff;
      position: relative;
      .goods {
        font-size: 30px;
        margin-bottom: 10px;
      }
      .msg {
        font-size: 24px;
        margin-bottom: 10px;
      }
      .ctime {
        font-size: 18px;
        margin-bottom: 10px;
      }
      .btn {
        cursor: pointer;
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 26px;
        width: 160px;
        height: 50px;
        border-radius: 25px;
        color: #000;
        background-color: #00d5d4;
      }
    }
  }
}
</style>
